<label class="col-sm-2 col-form-label text-right"> {{'title.document_types' | translate}}</label>
<div class="col-sm-4">
    <ng-mat-autocomplete [source]="documentAuto" [minChars]="0" [displayItem]="'item.name'"
        [ngModelOptions]="{ standalone: true }" [(ngModel)]="selected" (ngModelChange)="onChangeAutoCompleted()"
        [hasProgressBar]="true" [isFocused]="false">
    </ng-mat-autocomplete>
    <input autocomplete="off" type="hidden" class="form-control" name="name" [(ngModel)]="document.name" />
</div>

<label class="col-sm-2 col-form-label text-right">
    {{'enterprise_contract.table_headers.created_by' | translate}}</label>
<div class="col-sm-4">
    <ng-mat-autocomplete [source]="createrAuto" [minChars]="0" [displayItem]="'item.name'"
        [ngModelOptions]="{ standalone: true }" [(ngModel)]="selected1"
        (ngModelChange)="onChangeAutoCompletedForCreater()" [hasProgressBar]="true" [isFocused]="false">
    </ng-mat-autocomplete>
    <input autocomplete="off" type="hidden" class="form-control" name="nameCreater" [(ngModel)]="creater.name" />
</div>